import { render, staticRenderFns } from "./CardList.vue?vue&type=template&id=6b922f28&scoped=true&"
import script from "./CardList.vue?vue&type=script&lang=ts&"
export * from "./CardList.vue?vue&type=script&lang=ts&"
import style0 from "./CardList.vue?vue&type=style&index=0&id=6b922f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b922f28",
  null
  
)

export default component.exports